// The window a parcel card shows before switching the value year with anything unsaved (Philip 2026-10-21).
// ⛔ A TAX BILL CARD'S EDITS ARE STORED ONLY BY PROCESS, never by Save All — so with one pending there is no Save
// here: Save would switch years and lose them. Only Cancel (stay) or Discard (switch, keep nothing).
import React from 'react';
import { backdropProps } from '../utils/backdropClose';

export default function YearSwitchWindow({ billCardPending, saving, canSave, onCancel, onDiscard, onSave, s, c }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10002, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      {...backdropProps(onCancel)}>
      <div style={{ background: c.card, border: `1px solid ${c.border}`, borderRadius: '12px', boxShadow: '0 12px 40px rgba(0,0,0,0.4)', padding: '20px 22px', width: '380px', maxWidth: '90vw' }}>
        <div style={{ fontSize: '15px', fontWeight: '700', color: c.text, marginBottom: '6px' }}>Unsaved changes</div>
        <div style={{ fontSize: '13px', color: c.subtext, marginBottom: '18px', lineHeight: 1.4 }}>
          {billCardPending ? 'A tax bill card has unprocessed changes — Process it first or Discard.' : 'Save or Discard?'}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button type="button" onClick={onCancel} style={{ ...s.btnGhost }}>Cancel</button>
          <button type="button" onClick={onDiscard} style={{ ...s.btnGhost, color: '#f87171', borderColor: 'rgba(248,113,113,0.4)' }}>Discard</button>
          {!billCardPending && (
            <button type="button" onClick={onSave} disabled={saving || !canSave} style={s.btn}>{saving ? 'Saving…' : 'Save'}</button>
          )}
        </div>
      </div>
    </div>
  );
}
